import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FloatingActionButtonComponent } from "./floating-action-button.component";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MatIconModule } from "@angular/material/icon";
import { SharedModule } from "@shared/shared.module";

@NgModule({
	declarations: [FloatingActionButtonComponent],
	imports: [CommonModule, MatButtonModule, MatTooltipModule, MatIconModule, SharedModule],
	exports: [FloatingActionButtonComponent]
})
export class FloatingActionButtonModule {}
